import { GlButton, GlExperimentBadge, GlIcon, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { formatDate } from '~/lib/utils/datetime/date_format_utility';
import PageHeading from '~/vue_shared/components/page_heading.vue';
import ErrorsAlert from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/errors_alert.vue?vue3';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import { AI_CATALOG_MCP_SERVERS_EDIT_ROUTE } from '../router/constants';
import FormSection from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/form_section.vue?vue3';
import AiCatalogItemField from '../components/ai_catalog_item_field.vue';
export default {
    name: 'AiCatalogMcpServersShow',
    components: {
        AiCatalogItemField,
        ErrorsAlert,
        FormSection,
        GlButton,
        GlExperimentBadge,
        GlIcon,
        GlLink,
        PageHeading
    },
    mixins: [
        timeagoMixin,
        glAbilitiesMixin()
    ],
    props: {
        aiCatalogMcpServer: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            errors: [],
            errorTitle: null
        };
    },
    computed: {
        canEdit () {
            return Boolean(this.glAbilities.updateAiCatalogMcpServer);
        },
        editRoute () {
            return {
                name: AI_CATALOG_MCP_SERVERS_EDIT_ROUTE,
                params: {
                    id: this.$route.params.id
                }
            };
        },
        authTypeLabel () {
            if (this.aiCatalogMcpServer?.authType === 'OAUTH') {
                return s__('AICatalog|OAuth');
            }
            if (this.aiCatalogMcpServer?.authType === 'NO_AUTH') {
                return s__('AICatalog|No authentication');
            }
            return this.aiCatalogMcpServer?.authType;
        },
        metaData () {
            if (!this.aiCatalogMcpServer) return [];
            const items = [
                {
                    text: __('Created on'),
                    icon: 'calendar',
                    value: formatDate(this.aiCatalogMcpServer.createdAt, 'mmmm d, yyyy'),
                    testId: 'created-on'
                }
            ];
            if (this.aiCatalogMcpServer.updatedAt && this.aiCatalogMcpServer.updatedAt !== this.aiCatalogMcpServer.createdAt) {
                items.push({
                    text: __('Modified'),
                    icon: 'clock',
                    value: this.timeFormatted(this.aiCatalogMcpServer.updatedAt),
                    testId: 'modified'
                });
            }
            return items;
        }
    },
    methods: {
        setErrors ({ title = null, errors = [] } = {}) {
            this.errorTitle = title;
            this.errors = errors;
        },
        dismissErrors () {
            this.setErrors();
        }
    }
};
